import React from 'react'
import PropTypes from 'prop-types'
import InputField from '../../../../FormComponents/InputField/InputField'
import CheckboxesList from '../../../../FormComponents/CheckboxesList/CheckboxesList'
import ContactExpandedBlock from './ContactExpandedBlock'
import { checkValueInStore } from '../../../../AdditionalReportFilters/helpers'
import { clientConstants } from '../../../constants'
import { screenSize, page as pageIndex } from '../../../../../globals'
import { updateExpandedSection } from '../../../helpers'

class ClientContactRow extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false,
      currentRow: undefined,
      contacts: [],
      hidden: false,
      startNum: 10
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.expandSection = this.expandSection.bind(this)
    this.showDelete = this.showDelete.bind(this)
  }

  componentDidMount () {
    this.setState({ contacts: this.props.contacts, hidden: true })
    this.timerID = setInterval(() => this.changeState(), 1500)
  }

  changeState = () => {
    this.setState({ hidden: false })
  }

  componentWillUnmount () {
    clearInterval(this.timerID)
  }

  expandSection = (event) => {
    const { page } = this.props
    const { currentRow, expanded } = this.state
    const expandedValue = event.target.getAttribute('data-info') !== currentRow ||
      (event.target.getAttribute('data-info') === currentRow && !expanded)
    const currentValue = event.target.getAttribute('data-info')
    const prevValue = currentRow === undefined ? currentValue : currentRow
    this.setState({
      expanded: expandedValue,
      prevSelected: prevValue,
      currentRow: currentValue
    })
    updateExpandedSection(false, expandedValue, currentValue, prevValue)
    if (page !== pageIndex.cmd) {
      this.props.sendData(currentValue)
    }
  }

  showDelete = (id) => () => {
    this.props.sendData(id)
    this.props.showModal(`Delete-${id}`)
  }

  returnRowFields = (page, itemData, isEdited) => {
    const { trackData, updateData } = this.props
    const location = { id: itemData.ClientContactId, field: 'clientContacts' }
    return clientConstants.inputsList.clientContacts.map((elem, i) => {
      switch (elem.type) {
        case 'input':
          return <div className="client-contact-col border" key={i}>
            {window.innerWidth <= screenSize.extraSmall ? <div className="modal-titles">{elem.title}</div> : null}
            <InputField
              type="text"
              location={location}
              id={elem.name}
              value={checkValueInStore(elem.name, itemData[elem.name], trackData[itemData.ClientContactId])}
              updateData={updateData}
            />
          </div>
        case 'checkbox':
          return <div className="client-contact-col with-cb" key={i}>
            <CheckboxesList
              location={location}
              fieldData={[{
                id: elem.name,
                text: window.innerWidth <= screenSize.extraSmall ? elem.title : '',
                type: 'checkbox'
              }]}
              values={trackData[itemData.ClientContactId]}
              updateData={updateData}
              isEdited={isEdited}
            />
          </div>
      }
    })
  }

  returnRowItem = (num) => {
    const { contacts, editItem } = this.props
    let resultedArray = []
    if (editItem) {
      resultedArray.push(this.returnItem(editItem, editItem.ClientContactId))
    } else {
      const length = contacts.length > 10 ? num : contacts.length
      for (let i = 0; i <= length - 1; i++) {
        resultedArray.push(this.returnItem(contacts[i], i))
      }
    }
    return resultedArray
  }

  returnItem = (itemData, i) => {
    const { trackData, page, updateData, modal, isEdited } = this.props
    const { currentRow, expanded } = this.state
    const button = expanded && parseInt(currentRow) === itemData.ClientContactId ? '-' : '+'
    return <React.Fragment key={i}>
      <div className="row-item">
        {!modal
          ? <div
            className={expanded && parseInt(currentRow) === itemData.ClientContactId
              ? 'plus-button transformed' : 'plus-button'}
            onClick={this.expandSection}
            data-info={itemData.ClientContactId}
          >{page === pageIndex.dashboard ? ' ' : button}</div>
          : null}
        {this.returnRowFields(page, itemData, isEdited)}
      </div>
      <ContactExpandedBlock
        key={'contact' + i}
        itemData={itemData}
        page={page}
        trackData={trackData}
        updateData={updateData}
        updateExpandedSection={updateExpandedSection}
        expandSection={this.expandSection}
        modal={modal}
      />
    </React.Fragment>
  }

  handleScroll = (event) => {
    if (event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight) {
      const elementsList = this.props.field === 'dashboardUsers'
        ? document.querySelectorAll('.contact-rows .row-item')
        : document.querySelectorAll('.user-row')
      let nextItem = elementsList.length
      const data = this.props.contacts
      if (elementsList.length <= data.length - 5) {
        this.setState({
          startNum: nextItem + 5,
        })
      } else if (elementsList.length > data.length - 5 && elementsList.length < data.length) {
        this.setState({
          startNum: nextItem + (data.length - elementsList.length)
        })
      }
    }
  }

  render () {
    const { contacts } = this.props
    if (!contacts) {
      return null
    } else {
      const { startNum, hidden } = this.state
      return <div className="contact-rows" onScroll={this.handleScroll}>
        {hidden ? null : this.returnRowItem(startNum)}
      </div>
    }
  }

  static propTypes = {
    page: PropTypes.string,
    field: PropTypes.string,
    contacts: PropTypes.array,
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    modal: PropTypes.bool,
    editItem: PropTypes.bool,
    sendData: PropTypes.func,
    isEdited: PropTypes.object,
    showModal: PropTypes.func
  }
}

export default ClientContactRow



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ClientContacts/components/ClientContactRow.js